module.exports = __webpack_public_path__ + "static/media/background.95c2783d.jpg";